var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimitedReportingSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5C5 1.67188 5.67188 1 6.5 1H7.5C8.32812 1 9 1.67188 9 2.5V13.5C9 14.3281 8.32812 15 7.5 15H6.5C5.67188 15 5 14.3281 5 13.5V2.5ZM0 8.5C0 7.67188 0.671875 7 1.5 7H2.5C3.32812 7 4 7.67188 4 8.5V13.5C4 14.3281 3.32812 15 2.5 15H1.5C0.671875 15 0 14.3281 0 13.5V8.5ZM11.5 3H12.5C13.3281 3 14 3.67188 14 4.5V13.5C14 14.3281 13.3281 15 12.5 15H11.5C10.6719 15 10 14.3281 10 13.5V4.5C10 3.67188 10.6719 3 11.5 3Z",
    fill: "#F87171"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitedReportingSvg);
export default __webpack_public_path__ + "static/media/LimitedReportingSvg.00f245029372542588bbfd75bc8d55ed.svg";
export { ForwardRef as ReactComponent };